import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import AppPageTitle from '../components/shared/common/AppPageTitle';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 0,
    },
    top: {
        width: '100%',
        minHeight: theme.spacing(6),
        display: 'flex',
        alignItems: 'center',
        paddingInline: theme.spacing(2),
        paddingBlock: theme.spacing(1),
        boxSizing: 'border-box',
    },
    text: {
        margin: 0,
        color: (props) => props.titleColor || theme.palette.text.primary,
        fontSize: '1.2rem',
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: 1.2,
    },
    subtitle: {
        margin: 0,
        color: (props) => props.subtitleColor || theme.palette.text.primary,
        fontSize: '0.9rem',
        fontWeight: theme.typography.fontWeightRegular,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
    },
    iconWrap: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.primary,
        '& svg': {
            width: '100%',
            height: '100%',
        },
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
    },
    dividerWrap: {
        width: '100%',
        height: 1,
        position: 'relative',
    },
    titleActionSlot: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
}));

const AppTitleBand = ({ title, subtitle, icon, titleColor, subtitleColor, leadingAction, trailingAction }) => {
    const classes = useStyles({ titleColor, subtitleColor });

    return (
        <AppPageTitle
            title={title}
            subtitle={subtitle}
            icon={icon}
            align='start'
            dividerInsetX={16}
            dividerColor='#000000'
            dividerThickness={1}
            disableDefaultStyles
            className={classes.root}
            topClassName={classes.top}
            titleClassName={classes.text}
            subtitleClassName={classes.subtitle}
            dividerWrapClassName={classes.dividerWrap}
            iconWrapClassName={classes.iconWrap}
            leadingAction={
                leadingAction ? <Box className={classes.titleActionSlot}>{leadingAction}</Box> : null
            }
            trailingAction={
                trailingAction ? <Box className={classes.titleActionSlot}>{trailingAction}</Box> : null
            }
        />
    );
};

AppTitleBand.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    icon: PropTypes.node,
    titleColor: PropTypes.string,
    subtitleColor: PropTypes.string,
    leadingAction: PropTypes.node,
    trailingAction: PropTypes.node,
};

export default AppTitleBand;